import React, { Component } from 'react'
import SlideShow from './SlideShow'
import Menu from './Menu'
import { connect } from 'react-redux'
import { startLang } from '../actions'
import PropTypes from 'prop-types'
import getQueryByName from '../query'

import './App.css'

class App extends Component {

    componentDidMount() {
        this.props.startLang(getQueryByName('lang') === 'fr' ? 'fr' : 'en')
    }
    render() {
        return (
            <React.Fragment>
                <Menu/>
                <SlideShow/>
            </React.Fragment>
        )
    }
}

App.propTypes = {
    startLang: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch => ({
    startLang: lang => dispatch(startLang(lang))
})
export default connect(() => ({}), mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js